import ko = require("knockout");
import UserGroupPicker = require("./userGroupPicker");

export class UserGroupPickerRegistration {
    private static isRegistered: boolean;
    public static register() {
        if (!UserGroupPickerRegistration.isRegistered) {
            console.log("user group picker registration in progress");
            ko.components.register("userGroupPicker", {
                viewModel: UserGroupPicker.UserGroupPickerViewModel,
                template: require("./userGroupPicker.html")
            });
            UserGroupPickerRegistration.isRegistered = true;
        } else {
            console.log("user group picker already registered");
        }
    }
}
